<template>
  <div id='orderlist'>
        <van-tabs v-model="activeTab" @click='getOrderList' color="#323233">
            <van-tab title="全部"></van-tab>
            <van-tab title="待付款"></van-tab>
            <van-tab title="待发货"></van-tab>
            <van-tab title="待收货"></van-tab>
            <van-tab title="已完成"></van-tab>
        </van-tabs>
        <div class='shopItemList'>
            <OrderItem
               v-for="item in orderlist"
               :key="item.id"
               :orderinfo="item.orderinfo"
               :ordergoods="item.ordergoods"  
               @click="goDetail(item.id)"
            />
        </div> 
  </div>
</template>
<script>
import { Tab, Tabs} from 'vant';
import OrderItem from '@/components/orderitem'
export default {
   name: 'orderlist',
   data() {
      return {
        orderlist:[], 
        activeTab:0
      }
   }, 
   created(){
        if(this.$route.params.activeTab!=undefined) this.activeTab=parseInt(this.$route.params.activeTab);
        this.getList(); 
   },
   methods: {
      getList(){
         this.getOrderList(this.activeTab)
      },
      getOrderList(){
         this.$post("/order/getOrderList",{status:this.activeTab}).then((data)=>{
            if(data.result.success){      
                this.orderlist=data.result.info
            }else{
                this.$toast("网络正繁忙，请稍后再试")
            }
         })
      },
      goDetail(orderid){
         this.$go("/orderdetail/"+orderid)         
      }
   },
   components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        OrderItem
   }
}
</script>
<style scoped>
#orderlist{background-color:#F6F6F6;min-height: 100vh;padding-bottom: 60px;}
.shopItemList{padding: 0.25rem;margin-top:44px;}
::v-deep .van-tabs{position:fixed;width:100%;top:0;left:0;}
::v-deep .van-icon {display: flex;align-items: center;padding: 0.2rem;}
</style>